<!-- facilities -->
<div *ngIf="section ==  'IsFacilitie'">
    <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
        <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="title-box">
                        <div class="page-title-heading text-white">
                            <h1 class="title text-white">Accommodation</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mt-4">
        <div class="row mt-5">
            <div class="col-lg">
                <ul class="nav nav-pills border-bottom text-left" id="pills-tab" role="tablist">
                    <li class="nav-item text-blue">
                        <a class="nav-link active" id="pills-netb-tab" data-toggle="pill" href="#Exercise" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Accommodation</h2>
                        </a>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link " id="pills-netb-tab" data-toggle="pill" href="#TENS" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Yoga Hall</h2>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#SWD" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Annapurna Dining</h2>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Ultra" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Walking Track</h2>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Traction" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Reflexology track</h2>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Wax" role="tab"
                            aria-controls="pills-netb" aria-selected="false">
                            <h2>Recreation Area</h2>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link " id="pills-credit-tab" data-toggle="pill" href="#IFT" role="tab"
                            aria-controls="pills-credit" aria-selected="true">
                            <h2>Library</h2>
                        </a>
                    </li> -->
                </ul>

                <div class="tab-content" id="pills-tabContent">

                    <div class="tab-pane fade show active" id="Exercise" role="tabpanel"
                        aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5  text-left">
                            <!-- <p class="text-left ml-4">At Ashram we have 5 categories of accommodation </p>
                            <div class="text-left ml-4">
                                <br>
                                <p><i class="fa fa-check"></i> Ekant Niwas/Regular Single rooms </p>

                                <p><i class="fa fa-check"></i> Nisarga Kutir/Special Single rooms </p>

                                <p><i class="fa fa-check"></i> Nisarga Kutir/Twin Sharing Special rooms </p>

                                <p> <i class="fa fa-check"></i> Sadan/ Twin Sharing Cottages </p>

                                <p><i class="fa fa-check"></i> Bhavans/Twin Sharing Bungalows </p>

                                <p><i class="fa fa-check"></i> Ekant Niwas: Regular Single rooms without attached toilet
                                    and bathrooms </p>

                                <p><i class="fa fa-check"></i> Nisarga Kutir: Special Single rooms with attached toilet
                                    and bathroom. </p>

                                <p><i class="fa fa-check"></i> Nisarga Kutir: Single or Shared Twin bed rooms with
                                    attached
                                    toilet and bathroom </p>

                                <p><i class="fa fa-check"></i> Sadan: Single or Shared Twin bed Cottages with attached
                                    toilet
                                    and bathroom </p>

                                <p> <i class="fa fa-check"></i> Bhavans: Single or Shared Twin bed Bungalows with
                                    attached
                                    toilet, bathroom, balcony and a common hall.</p>
                            </div> -->
                            <div class="text-left ml-4">
                                <p><i class="fa fa-check"></i> General ward(Female)</p>
                                <p><i class="fa fa-check"></i> Economy Twin sharing</p>
                                <p><i class="fa fa-check"></i> Standard Twin sharing</p>
                                <p><i class="fa fa-check"></i> Standard Single</p>
                                <p><i class="fa fa-check"></i> Special Twin Sharing</p>
                                <p><i class="fa fa-check"></i> Special Single</p>
                                <p><i class="fa fa-check"></i> Deluxe Non AC twin sharing</p>
                                <p><i class="fa fa-check"></i> Deluxe AC twin sharing</p>
                                <p><i class="fa fa-check"></i> Super Deluxe non AC twin sharing</p>
                                <p><i class="fa fa-check"></i> Super Deluxe Ac twin sharing</p>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="TENS" role="tabpanel" aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5">
                            <p class="text-left ml-3 mr-4"> Ashram has 2 Yoga halls; “Yoga Sadhana” and “Prerana Mandir”
                                that can accommodate 70
                                people at a time. 4 batches of Yoga sessions, prayer meditation and Trataka sessions are
                                conducted in these halls on a daily basis.</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="SWD" role="tabpanel" aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5 text-left">
                            <p class="text-left ml-3 mr-4">Annapurna dining is located in the heart of ashram and serves
                                Satwik food. Various
                                herbal teas, vegetable and fruit juices, Salads, soups and a millet based meal are
                                served here.
                            </p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Ultra" role="tabpanel" aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5  text-left">
                            <p class="text-left ml-3">Ashram has a one kilometer long scenic walking track by the side
                                of a Chikku farm. You
                                can spot a variety of flora and fauna here.
                            </p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="Traction" role="tabpanel" aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5  text-left">
                            <p class="text-left ml-3">Reflexology refers to the application of pressure on different
                                areas of foot and palm.
                                The pebble pool at Ashram is designed using pebbles of various shapes and sizes so as to
                                offer pressure in particular areas of the feet. The temperature of water along with the
                                pressure offered by stones gives a relaxing effect.
                            </p>

                        </div>
                    </div>
                    <div class="tab-pane fade" id="Wax" role="tabpanel" aria-labelledby="pills-netb-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5  text-left">
                            <p>A recreation room for sadhakas with various indoor games like carom, chess and table
                                tennis and a badminton court is present in the campus.</p>
                        </div>
                    </div>
                    <div class="tab-pane fade " id="IFT" role="tabpanel" aria-labelledby="pills-credit-tab">
                        <div class="payment-banner py-5 bg-light text-center mb-5">
                            <p class="text-left ml-3 mr-5"> The ashram has a huge library of books on various subjects
                                such as philosophy,
                                religious, psychology, naturopathy, dietetics, nutrition etc. There is also a reading
                                room for general awareness of current affairs news and views. Besides magazines in
                                English, Marathi and Sindhi are also available.</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>

<!-- services-->

<div *ngIf="section ==  'IsServices'">
    <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
        <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="title-box">
                        <div class="page-title-heading text-white">
                            <h1 class="title text-white">Services</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="container mt-5">
        <div class="row">
            <div class="text-left" style="font-size: 16px;">
                <ul class="ml-3">
                    <p>Sadhakas can have free access to wifi during their stay at Ashram.</p>
                    <p>There will be lectures on health and lifestyle daily evenings by Doctors and Yoga
                        Acharyas.</p>
                    <p>Every Saturday video shows on various health-related topics are displayed for
                        Sadhakas.</p>
                    <p>Laundry services can be availed at a nominal rate.</p>
                    <p>24 hours power back up.</p>
                    <p>In campus, utility stores to buy essentials.</p>
                    <p>In campus fruit stall for procuring fruits.</p>
                    <p>Free parking is available in the campus.</p>
                </ul>
            </div>
        </div>
    </div> -->


    <div class="container mt-5" style="max-width:900px; margin:auto; padding:20px;">
        <!-- <h2 style="text-align:center; font-size:26px; font-weight:600; margin-bottom:25px; color:#2c3e50;">
            Facilities at Ashram
        </h2> -->
        <div class="row" style="display:grid; grid-template-columns:repeat(auto-fit,minmax(300px,1fr)); gap:20px;">

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08); transition:0.3s;">
                <span style="font-size:24px; margin-right:12px; color:#3498db;">📶</span>
                <p style="margin:0; font-size:16px; color:#444;">Free Wi-Fi available during stay.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#27ae60;">👨‍⚕️</span>
                <p style="margin:0; font-size:16px; color:#444;">Daily evening lectures by Doctors & Yoga Acharyas.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#e67e22;">🎥</span>
                <p style="margin:0; font-size:16px; color:#444;">Health-related video shows every Saturday.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#9b59b6;">🧺</span>
                <p style="margin:0; font-size:16px; color:#444;">Laundry services at nominal rates.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#f39c12;">⚡</span>
                <p style="margin:0; font-size:16px; color:#444;">24-hour power backup.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#2ecc71;">🏪</span>
                <p style="margin:0; font-size:16px; color:#444;">Utility stores available in campus.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#e74c3c;">🍎</span>
                <p style="margin:0; font-size:16px; color:#444;">Fruit stall available inside campus.</p>
            </div>

            <div
                style="background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:20px; display:flex; align-items:center; box-shadow:0 4px 12px rgba(0,0,0,0.08);">
                <span style="font-size:24px; margin-right:12px; color:#34495e;">🚗</span>
                <p style="margin:0; font-size:16px; color:#444;">Free parking facility available.</p>
            </div>

        </div>
    </div>




</div>


<div class="" *ngIf="section ==  'IsOnlineyoga'">
    <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
        <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="title-box">
                        <div class="page-title-heading text-white">
                            <h1 class="title text-white">Online Yoga</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mt-5">
        <div class="row">
        </div>
    </div>
</div>